var render = function render(){
  var _this$sources;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pull-model"
  }, [_vm._m(0), _c('div', [_c('div', {
    staticClass: "pull-model__status mb-4",
    staticStyle: {
      "width": "120px"
    }
  }, [_c('span', {
    staticClass: "feeds__status-text mr-4"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-globe inline"
  }), _vm._v(" Sources: "), ((_this$sources = this.sources) === null || _this$sources === void 0 ? void 0 : _this$sources.length) > 0 ? _c('strong', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(this.filteredSources.length))]) : _c('vue-loaders-ball-beat', {
    attrs: {
      "color": "var(--redstone-red-color)",
      "scale": "0.5"
    }
  })], 1)])])]), _c('b-table', {
    staticClass: "pull-model",
    attrs: {
      "id": "sources-table",
      "stacked": "md",
      "sort-icon-left": "",
      "busy": _vm.loading,
      "hover": "",
      "sortBy": "id",
      "items": _vm.filteredSources,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(name)",
      fn: function fn(source) {
        return [_c('div', {
          staticClass: "source-name"
        }, [_c('img', {
          staticClass: "source-logo",
          attrs: {
            "src": source.item.logoURI
          }
        }), _c('a', {
          attrs: {
            "href": source.item.url,
            "target": "_blank"
          }
        }, [_c('span', {
          staticClass: "ml-3"
        }, [_vm._v(" " + _vm._s(source.item.id) + " ")])])])];
      }
    }, {
      key: "cell(numberOfFeeds)",
      fn: function fn(source) {
        var _vm$tokenSourceCounts;
        return [_c('div', {
          staticClass: "source-name"
        }, [_c('span', {
          staticClass: "ml-3"
        }, [_vm._v(" " + _vm._s((_vm$tokenSourceCounts = _vm.tokenSourceCounts) === null || _vm$tokenSourceCounts === void 0 ? void 0 : _vm$tokenSourceCounts[source.item.id]) + " ")])])];
      }
    }])
  }), _vm.showReportsLink ? _c('div', {
    staticClass: "report-source-link"
  }, [_vm._v(" Data source: "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/redstone-finance/redstone-reports"
    }
  }, [_vm._v(" github.com/redstone-finance/redstone-reports ")])]) : _vm._e()], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pull-model__view-details"
  }, [_c('h1', [_vm._v("RedStone Sources")]), _c('p', [_vm._v(" Access real-time token pricing from multiple trusted sources with reliable infrastructure for accurate DeFi applications. ")])]);

}]

export { render, staticRenderFns }